module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vresp5-f78f05013472a5307195266396fa23ea.jpg";